/*
 * TUMLE language and currency pickers (snippets/tumle_language-picker.liquid,
 * snippets/tumle_currency-picker.liquid): an open list closes when the
 * visitor taps outside it or presses Escape. Opening and choosing work
 * without this file (plain <details> and form).
 * Loaded by sections/header.liquid.
 */
(function () {
  var SELECTOR = '.tumle_language__details[open], .tumle_currency__details[open]';

  document.addEventListener('click', function (event) {
    document.querySelectorAll(SELECTOR).forEach(function (details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(SELECTOR).forEach(function (details) {
      details.open = false;
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();
